export default "__VITE_ASSET__BPN$As24__"